/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Import_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Translation import complete" |
*
* @param {Translation_Import_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_success_toast = /** @type {((inputs?: Translation_Import_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation de la traduction terminée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsimport abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione traduzione completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт перевода завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de traducción completada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译导入完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳インポート完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद आयात पूर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação da tradução concluída")
	return /** @type {LocalizedString} */ ("Translation import complete")
});